import React from 'react';
import { SectionHeader } from './ui/SectionHeader';
import { problems } from '../data/content';
export function ProblemSection() {
  return <section aria-labelledby="problema" className="bg-mist" data-id="element-110" data-mp="2lu4o5ip4lm78">
      <div className="mx-auto max-w-3xl px-4 py-4 sm:py-8" data-id="element-111" data-mp="30hhb9bukzzzq">
        <SectionHeader id="problema" eyebrow="¿Te suena familiar?" title="Das clases de Electromecánica, pero preparar contenidos, actividades y prácticas para cada tema te lleva demasiado tiempo." description="Si eres profesor técnico, instructor o estás preparando material para enseñar, probablemente conozcas alguna de estas situaciones:" data-id="element-112" data-mp="30j0w7fr6mz7u" />
        <ul className="mt-2.5 grid gap-1.5 sm:grid-cols-2 sm:gap-2" data-id="element-113" data-mp="3jdplku2gb11w">
          {problems.map(p => {
          const Icon = p.icon;
          return <li key={p.title} className="flex gap-2.5 rounded-lg border-l-4 border-alert bg-white p-2.5 shadow-sm" data-id="element-114" data-mp="1p2u1ovltfzjt">
                <Icon size={18} aria-hidden="true" className="mt-0.5 flex-shrink-0 text-tech" data-id="element-115" data-mp="1k4simaoe408c" />
                <div data-id="element-116" data-mp="jeof04qybel2">
                  <h3 className="font-condensed text-sm font-bold text-navy sm:text-base" data-id="element-117" data-mp="jbadszu0xbf7">{p.title}</h3>
                  <p className="mt-0.5 text-[0.78rem] leading-snug text-navy/75 sm:text-sm" data-id="element-118" data-mp="o9u051cj4p83">{p.desc}</p>
                </div>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}